import { render } from "./ReferalScreen.vue?vue&type=template&id=0cf00faa&scoped=true"
import script from "./ReferalScreen.vue?vue&type=script&lang=js"
export * from "./ReferalScreen.vue?vue&type=script&lang=js"

import "./ReferalScreen.vue?vue&type=style&index=0&id=0cf00faa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf00faa"]])

export default __exports__